import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { classifyApiError, i18nKeyForCategory, toErrorMessage } from './api-error';
import type { ClassifiedApiError } from './api-error';

export function useApiError() {
  const { t } = useTranslation();

  const translate = useCallback((error: unknown): string => toErrorMessage(error, t), [t]);

  const classify = useCallback(
    (error: unknown): ClassifiedApiError & { message: string } => {
      const c = classifyApiError(error);
      return { ...c, message: c.serverMessage ?? t(i18nKeyForCategory(c.category)) };
    },
    [t],
  );

  return { translate, classify };
}
